import { eventBus, EVENTS } from "../event_bus";
import Switcher from "./switcher.vue";
export default {
  name: "Modal",
  components: {
    Switcher
  },
  props: {
    render: Boolean,
    onShow: Function,
    onClose: Function
  },
  methods: {
    show() {
      this.$refs.switcher.show();
      eventBus.$on(EVENTS.Body.Click, this.onBodyClick);
    },

    close() {
      this.$refs.switcher.close();
      eventBus.$off(EVENTS.Body.Click, this.onBodyClick);
    },

    turn() {
      this.$refs.switcher.isDisplayed ? this.close() : this.show();
    },

    onBodyClick() {
      this.close();
    }

  }
};